module.exports = __webpack_public_path__ + "img/symbol_1.7a65c5cc.png";